import React from "react";
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import "./index.css";
import { MyRoutes } from "./app/index";
import { wlTheme } from "./theme/wishlistTheme";
import "@fontsource/nunito/300.css";
import "@fontsource/ibm-plex-serif/300.css";
import { createRoot } from 'react-dom/client';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <ChakraProvider theme={wlTheme}>
      <ColorModeScript />
      <MyRoutes />
    </ChakraProvider>
  </React.StrictMode>,
);
